import { render } from "./readBookClubInfo.vue?vue&type=template&id=fd5490fe&scoped=true"
import script from "./readBookClubInfo.vue?vue&type=script&lang=js"
export * from "./readBookClubInfo.vue?vue&type=script&lang=js"

import "./readBookClubInfo.vue?vue&type=style&index=0&id=fd5490fe&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5490fe"]])

export default __exports__